import React from "react";
import { string } from "prop-types";
import cx from "classnames";

const propTypes = {
  srcset: string,
  srcSet: string,
  height: string,
  width: string,
  alt: string,
  sizes: string,
  className: string,
  loading: string,
};

const defaultProps = {
  srcset: `
    https://picsum.photos/seed/imageelement/400/300 400w,
    https://picsum.photos/seed/imageelement/800/600 800w,
    https://picsum.photos/seed/imageelement/1200/900 1200w,
    https://picsum.photos/seed/imageelement/1600/1200 1600w,
    https://picsum.photos/seed/imageelement/2000/1500 2000w,
    https://picsum.photos/seed/imageelement/2400/1800 2400w,
    https://picsum.photos/seed/imageelement/2800/2100 2800w,
    https://picsum.photos/seed/imageelement/3200/2400 3200w"
  `,
  alt: "",
  sizes: "(min-width: 1230px) 1170px, 100vw",
  className: "",
  loading: "lazy", // put this here so it can be overridden
  height: "2400",
  width: "3200",
};

const ImageElement = (props) => {
  const { alt, sizes, className, loading, height, width } = props;
  const srcset = props.srcSet ? props.srcSet : props.srcset; // fallback srcset makes more sense

  return (
    <img
      className={cx("image-element", className)}
      srcSet={srcset}
      alt={alt}
      sizes={sizes}
      loading={loading}
      height={height}
      width={width}
      style={{ "--image-height": height, "--image-width": width }}
    />
  );
};

ImageElement.propTypes = propTypes;
ImageElement.defaultProps = defaultProps;

export { propTypes };
export default ImageElement;
